import styled from 'styled-components';
import { Theme } from '@mui/material';

export const ResetText = styled.div<{ theme: Theme }>`
  font-weight: 600;
  font-size: 14px;
  color: ${(props) => props.theme?.palette?.primary?.main};
`;
